module.exports = __webpack_public_path__ + "img/mfb.399f5018.svg";